const control_calidad_base = `ver-control-calidad`

const materia_prima_i = `${control_calidad_base}-informes-materia-prima`
const materia_prima_t = `${control_calidad_base}-transacciones-materia-prima`

const prod_terminado_i = `${control_calidad_base}-informes-prod-terminado`
const prod_terminado_t = `${control_calidad_base}-transacciones-prod-terminado`

const valor_agregado_i = `${control_calidad_base}-informes-valor-agregado`
const valor_agregado_t = `${control_calidad_base}-transacciones-valor-agregado`

const proceso_entero_i = `${control_calidad_base}-informes-proceso-entero`
const proceso_entero_t = `${control_calidad_base}-transacciones-proceso-entero`

const proceso_cola_i = `${control_calidad_base}-informes-proceso-cola`
const proceso_cola_t = `${control_calidad_base}-transacciones-proceso-cola`

const embarque_despacho_i = `${control_calidad_base}-informes-embarque-despacho`
const embarque_despacho_t = `${control_calidad_base}-transacciones-embarque-despacho`

const salmuera_i = `${control_calidad_base}-informes-salmuera`
const salmuera_t = `${control_calidad_base}-transacciones-salmuera`

const cocido_i = `${control_calidad_base}-informes-cocido`
const cocido_t = `${control_calidad_base}-transacciones-cocido`

const calidad_i = `${control_calidad_base}-informes-calidad`
const calidad_t = `${control_calidad_base}-transacciones-calidad`

const laboratorio_i = `${control_calidad_base}-informes-laboratorio`
const laboratorio_t = `${control_calidad_base}-transacciones-laboratorio`

const config = `${control_calidad_base}-configurar`
// const acciones_correctivas = 'ver-control-calidad-informes-calidad-acciones-correctivas'

export const ControlCalidadPermisos = {
    CONFIGURACION: {
        PROCESOS: {
            VISUALIZAR: `${config}-procesos-visualizar`,
        },
        PERMISOS: {
            VISUALIZAR: `${config}-permisos-visualizar`,
        },
        FIRMAS: {
            CAMBIAR_PASSWORD: `${config}-firmas-contrasena`,
            USUARIOS: `${config}-firmas-usuarios`,
        },
        DIFUSION_CORREOS: {
            VISUALIZAR: `${config}-correos-visualizar`,
        },
        PODERES: {
            VISUALIZAR: `${config}-poderes-visualizar`,
        },
    },
    CALIDAD: {
        INFORMES_GENERAL: {
            BASE: `${control_calidad_base}-informes`,
            VISUALIZAR: `${calidad_i}-general-visualizar`,
        },
        TRANSACCIONES_GENERAL: {
            BASE: `${control_calidad_base}-transacciones`,
            VISUALIZAR: `${calidad_t}-general-visualizar`,
        },
        CERTIFICADO: {
            INFORMES: {
                VISUALIZAR: `${calidad_i}-certificado-visualizar`,
            },
        },
        ACCIONES_CORRECTIVAS: {
            INFORMES: {
                // Agregar los permisos correspondientes
                // Todo detallado
                // Lo usaran todos, monitores, supervisores, etc.
                VISUALIZAR: `${calidad_i}-acciones-correctivas-visualizar`,
                ASIGNAR: `${calidad_i}-acciones-correctivas-asignar`,
                APROBAR: `${calidad_i}-acciones-correctivas-aprobar`,
                AUTORIZAR: `${calidad_i}-acciones-correctivas-autorizar`,
                PSEUDOAPROBAR: `${calidad_i}-acciones-correctivas-pseudoaprobar`,
            },
            TRANSACCIONES: `${calidad_t}-acciones-correctivas-rccc201`,
        },
        ACCIONES_CORRECTIVAS_AREAS_ASIGNADAS: {
            INFORMES: {
                VISUALIZAR: `${calidad_i}-acciones-correctivas-areas-asignadas-visualizar`,
            },
        },
        ACCIONES_CORRECTIVAS_USUARIOS_ASIGNADOS: {
            INFORMES: {
                VISUALIZAR: `${calidad_i}-acciones-correctivas-usuarios-asignados-visualizar`,
            },
        },
        TRAZABILIDAD: {
            VISUALIZAR: `${calidad_i}-trazabilidad-visualizar`,
            LOTES: `${calidad_i}-trazabilidad-lotes`,
        },
    },
    COCIDO: {
        VENTANA_INFOMRES: `${cocido_i}-ventana`,
        VENTANA_TRANSACCIONES: `${cocido_t}-ventana`,
        RCCC219: {
            INFORMES: {
                VISUALIZAR: `${cocido_i}-rccc219-visualizar`,
                VISUALIZAR_PDF: `${cocido_i}-rccc219-visualizar-pdf`,
                FIRMAR: `${cocido_i}-rccc219-firmar`,
                EDITAR: `${cocido_i}-rccc219-editar`,
                DESCARGAR_PDF: `${cocido_i}-rccc219-descargar-pdf`,
                DESCARGAR_EXCEL: `${cocido_i}-rccc219-descargar-excel`,
                DESCARGAR_DATA: `${cocido_i}-rccc219-descargar-data`,
                AUDTH: `${cocido_i}-rccc219-auditoria`,
                EDITAR_CORRECCIONES: `${cocido_i}-rccc219-editar-correcciones`,
            },
        },
    },
    SALMUERA: {
        VENTANA_INFOMRES: `${salmuera_i}-ventana`,
        VENTANA_TRANSACCIONES: `${salmuera_t}-ventana`,
        RCCC15: {
            INFORMES: {
                VISUALIZAR: `${salmuera_i}-rccc15-visualizar`,
                VISUALIZAR_PDF: `${salmuera_i}-rccc15-visualizar-pdf`,
                FIRMAR: `${salmuera_i}-rccc15-firmar`,
                EDITAR: `${salmuera_i}-rccc15-editar`,
                DESCARGAR_PDF: `${salmuera_i}-rccc15-descargar`,
                DESCARGAR_EXCEL: `${salmuera_i}-rccc15-descargar-excel`,
                DESCARGAR_DATA: `${salmuera_i}-rccc15-descargar-data`,
                AUDTH: `${salmuera_i}-rccc15-auditoria`,
                EDITAR_CORRECCIONES: `${salmuera_i}-rccc15-editar-correcciones`,
            },
        },
    },
    EMBARQUE_DESPACHO: {
        VENTANA_INFOMRES: `${embarque_despacho_i}-ventana`,
        VENTANA_TRANSACCIONES: `${embarque_despacho_t}-ventana`,
        RCCC25: {
            INFORMES: {
                VISUALIZAR: `${embarque_despacho_i}-rccc25-visualizar`,
                VISUALIZAR_PDF: `${embarque_despacho_i}-rccc25-visualizar-pdf`,
                FIRMAR: `${embarque_despacho_i}-rccc25-firmar`,
                EDITAR: `${embarque_despacho_i}-rccc25-editar`,
                DESCARGAR_PDF: `${embarque_despacho_i}-rccc25-descargar-pdf`,
                DESCARGAR_EXCEL: `${embarque_despacho_i}-rccc25-descargar-excel`,
                DESCARGAR_DATA: `${embarque_despacho_i}-rccc25-descargar-data`,
                AUDTH: `${embarque_despacho_i}-rccc25-auditoria`,
                EDITAR_CORRECCIONES: `${embarque_despacho_i}-rccc25-editar-correcciones`,
            },
            TRANSACCIONES: `${embarque_despacho_i}-rccc25`,
        },
        RCCC26: {
            INFORMES: {
                VISUALIZAR: `${embarque_despacho_i}-rccc26-visualizar`,
                VISUALIZAR_PDF: `${embarque_despacho_i}-rccc26-visualizar-pdf`,
                FIRMAR: `${embarque_despacho_i}-rccc26-firmar`,
                EDITAR: `${embarque_despacho_i}-rccc26-editar`,
                DESCARGAR_PDF: `${embarque_despacho_i}-rccc26-descargar-pdf`,
                DESCARGAR_EXCEL: `${embarque_despacho_i}-rccc26-descargar-excel`,
                DESCARGAR_DATA: `${embarque_despacho_i}-rccc26-descargar-data`,
                AUDTH: `${embarque_despacho_i}-rccc26-auditoria`,
                EDITAR_CORRECCIONES: `${embarque_despacho_i}-rccc26-editar-correcciones`,
            },
            TRANSACCIONES: `${embarque_despacho_i}-rccc26`,
        },
    },
    PROCESO_ENTERO: {
        VENTANA_INFOMRES: `${proceso_entero_i}-ventana`,
        VENTANA_TRANSACCIONES: `${proceso_entero_t}-ventana`,
        RCCC07: {
            INFORMES: {
                VISUALIZAR: `${proceso_entero_i}-rccc07-visualizar`,
                VISUALIZAR_PDF: `${proceso_entero_i}-rccc07-visualizar-pdf`,
                FIRMAR: `${proceso_entero_i}-rccc07-firmar`,
                EDITAR: `${proceso_entero_i}-rccc07-editar`,
                DESCARGAR_PDF: `${proceso_entero_i}-rccc07-descargar-pdf`,
                DESCARGAR_EXCEL: `${proceso_entero_i}-rccc07-descargar-excel`,
                DESCARGAR_DATA: `${proceso_entero_i}-rccc07-descargar-pdf`,
                AUDTH: `${proceso_entero_i}-rccc07-auditoria`,
                EDITAR_CORRECCIONES: `${proceso_entero_i}-rccc07-editar-correcciones`,
            },
            TRANSACCIONES: `${proceso_entero_t}-rccc07`,
        },
        RCCC08: {
            INFORMES: {
                VISUALIZAR: `${proceso_entero_i}-rccc08-visualizar`,
                VISUALIZAR_PDF: `${proceso_entero_i}-rccc08-visualizar-pdf`,
                FIRMAR: `${proceso_entero_i}-rccc08-firmar`,
                EDITAR: `${proceso_entero_i}-rccc08-editar`,
                DESCARGAR_PDF: `${proceso_entero_i}-rccc08-descargar-pdf`,
                DESCARGAR_EXCEL: `${proceso_entero_i}-rccc08-descargar-excel`,
                DESCARGAR_DATA: `${proceso_entero_i}-rccc08-descargar-data`,
                AUDTH: `${proceso_entero_i}-rccc08-auditoria`,
                EDITAR_CORRECCIONES: `${proceso_entero_i}-rccc08-editar-correcciones`,
            },
            TRANSACCIONES: `${proceso_entero_t}-rccc08`,
        },
        CCF065: {
            INFORMES: {
                VISUALIZAR: `${proceso_entero_i}-ccf065-visualizar`,
                VISUALIZAR_PDF: `${proceso_entero_i}-ccf065-visualizar-pdf`,
                FIRMAR: `${proceso_entero_i}-ccf065-firmar`,
                EDITAR: `${proceso_entero_i}-ccf065-editar`,
                DESCARGAR_PDF: `${proceso_entero_i}-ccf065-descargar-pdf`,
                DESCARGAR_EXCEL: `${proceso_entero_i}-ccf065-descargar-excel`,
                DESCARGAR_DATA: `${proceso_entero_i}-ccf065-descargar-data`,
                AUDTH: `${proceso_entero_i}-ccf065-auditoria`,
                EDITAR_CORRECCIONES: `${proceso_entero_i}-ccf065-editar-correcciones`,
            },
            TRANSACCIONES: `${proceso_entero_t}-ccf065`,
        },
    },
    PROCESO_COLA: {
        RCCC23: {
            INFORMES: {
                VISUALIZAR: `${proceso_cola_i}-rccc23-visualizar`,
                VISUALIZAR_PDF: `${proceso_cola_i}-rccc23-visualizar-pdf`,
                FIRMAR: `${proceso_cola_i}-rccc23-firmar`,
                EDITAR: `${proceso_cola_i}-rccc23-editar`,
                DESCARGAR_PDF: `${proceso_cola_i}-rccc23-descargar-pdf`,
                DESCARGAR_EXCEL: `${proceso_cola_i}-rccc23-descargar-excel`,
                DESCARGAR_DATA: `${proceso_cola_i}-rccc23-descargar-data`,
                AUDTH: `${proceso_cola_i}-rccc23-auditoria`,
                EDITAR_CORRECCIONES: `${proceso_cola_i}-rccc23-editar-correcciones`,
            },
            TRANSACCIONES: `${proceso_cola_t}-rccc23`,
        },
        CCF075: {
            INFORMES: {
                VISUALIZAR: `${proceso_cola_i}-ccf075-visualizar`,
                VISUALIZAR_PDF: `${proceso_cola_i}-ccf075-visualizar-pdf`,
                FIRMAR: `${proceso_cola_i}-ccf075-firmar`,
                EDITAR: `${proceso_cola_i}-ccf075-editar`,
                DESCARGAR_PDF: `${proceso_cola_i}-ccf075-descargar-pdf`,
                DESCARGAR_EXCEL: `${proceso_cola_i}-ccf075-descargar-excel`,
                DESCARGAR_DATA: `${proceso_cola_i}-ccf075-descargar-data`,
                AUDTH: `${proceso_cola_i}-ccf075-auditoria`,
                EDITAR_CORRECCIONES: `${proceso_cola_i}-ccf075-editar-correcciones`,
            },
            TRANSACCIONES: `${proceso_cola_t}-ccf075`,
        },
    },
    VALOR_AGREGADO: {
        VENTANA_INFOMRES: `${valor_agregado_i}-ventana`,
        VENTANA_TRANSACCIONES: `${valor_agregado_t}-ventana`,
        RCCC103: {
            INFORMES: {
                VISUALIZAR: `${valor_agregado_i}-rccc103-visualizar`,
                VISUALIZAR_PDF: `${valor_agregado_i}-rccc103-visualizar-pdf`,
                FIRMAR: `${valor_agregado_i}-rccc103-firmar`,
                EDITAR: `${valor_agregado_i}-rccc103-editar`,
                DESCARGAR_PDF: `${valor_agregado_i}-rccc103-descargar-pdf`,
                DESCARGAR_EXCEL: `${valor_agregado_i}-rccc103-descargar-excel`,
                DESCARGAR_DATA: `${valor_agregado_i}-rccc103-descargar-data`,
                AUDTH: `${valor_agregado_i}-rccc103-auditoria`,
                EDITAR_CORRECCIONES: `${valor_agregado_i}-rccc103-editar-correcciones`,
            },
            TRANSACCIONES: `${valor_agregado_t}-rccc103`,
        },
        RCCC105: {
            INFORMES: {
                VISUALIZAR: `${valor_agregado_i}-rccc105-visualizar`,
                VISUALIZAR_PDF: `${valor_agregado_i}-rccc105-visualizar-pdf`,
                FIRMAR: `${valor_agregado_i}-rccc105-firmar`,
                EDITAR: `${valor_agregado_i}-rccc105-editar`,
                DESCARGAR_PDF: `${valor_agregado_i}-rccc105-descargar-pdf`,
                DESCARGAR_EXCEL: `${valor_agregado_i}-rccc105-descargar-excel`,
                DESCARGAR_DATA: `${valor_agregado_i}-rccc105-descargar-data`,
                AUDTH: `${valor_agregado_i}-rccc105-auditoria`,
                EDITAR_CORRECCIONES: `${valor_agregado_i}-rccc105-editar-correcciones`,
            },
            TRANSACCIONES: `${valor_agregado_t}-rccc105`,
        },
        RCCC224: {
            INFORMES: {
                VISUALIZAR: `${valor_agregado_i}-rccc224-visualizar`,
                VISUALIZAR_PDF: `${valor_agregado_i}-rccc224-visualizar-pdf`,
                FIRMAR: `${valor_agregado_i}-rccc224-firmar`,
                EDITAR: `${valor_agregado_i}-rccc224-editar`,
                DESCARGAR_PDF: `${valor_agregado_i}-rccc224-descargar-pdf`,
                DESCARGAR_EXCEL: `${valor_agregado_i}-rccc224-descargar-excel`,
                DESCARGAR_DATA: `${valor_agregado_i}-rccc224-descargar-data`,
                AUDTH: `${valor_agregado_i}-rccc224-auditoria`,
                EDITAR_CORRECCIONES: `${valor_agregado_i}-rccc224-editar-correcciones`,
            },
            TRANSACCIONES: `${valor_agregado_t}-rccc224`,
        },
    },
    MATERIA_PRIMA: {
        VENTANA_INFORMES: `${materia_prima_i}-ventana`,
        VENTANA_TRANSACCIONES: `${materia_prima_t}-ventana`,
        RCMP01: {
            INFORMES: {
                VISUALIZAR: `${materia_prima_i}-rcmp01-visualizar`,
                VISUALIZAR_PDF: `${materia_prima_i}-rcmp01-visualizar-pdf`,
                FIRMAR: `${materia_prima_i}-rcmp01-firmar`,
                EDICION_RAPIDA: `${materia_prima_i}-rcmp01-edicion-rapida`,
                EDITAR: `${materia_prima_i}-rcmp01-editar`,
                DESCARGAR_PDF: `${materia_prima_i}-rcmp01-descargar-pdf`,
                DESCARGAR_EXCEL: `${materia_prima_i}-rcmp01-descargar-excel`,
                DESCARGAR_DATA: `${materia_prima_i}-rcmp01-descargar-data`,
                AUDTH: `${materia_prima_i}-rcmp01-auditoria`,
                EDITAR_CORRECCIONES: `${materia_prima_i}-rcmp01-editar-correcciones`,
            },
            TRANSACCIONES: `${materia_prima_t}-rcmp01`,
        },
        CCF072: {
            INFORMES: {
                VISUALIZAR: `${materia_prima_i}-ccf072-visualizar`,
                VISUALIZAR_PDF: `${materia_prima_i}-ccf072-visualizar-pdf`,
                FIRMAR: `${materia_prima_i}-ccf072-firmar`,
                EDICION_RAPIDA: `${materia_prima_i}-ccf072-edicion-rapida`,
                EDITAR: `${materia_prima_i}-ccf072-editar`,
                DESCARGAR_PDF: `${materia_prima_i}-ccf072-descargar-pdf`,
                DESCARGAR_EXCEL: `${materia_prima_i}-ccf072-descargar-excel`,
                DESCARGAR_DATA: `${materia_prima_i}-ccf072-descargar-data`,
                AUDTH: `${materia_prima_i}-ccf072-auditoria`,
                EDITAR_CORRECCIONES: `${materia_prima_i}-ccf072-editar-correcciones`,
            },
            TRANSACCIONES: `${materia_prima_t}-ccf072`,
        },
        RCCC194: {
            INFORMES: {
                VISUALIZAR: `${materia_prima_i}-rccc194-visualizar`,
                VISUALIZAR_PDF: `${materia_prima_i}-rccc194-visualizar-pdf`,
                FIRMAR: `${materia_prima_i}-rccc194-firmar`,
                EDITAR: `${materia_prima_i}-rccc194-editar`,
                DESCARGAR_PDF: `${materia_prima_i}-rccc194-descargar-pdf`,
                DESCARGAR_EXCEL: `${materia_prima_i}-rccc194-descargar-excel`,
                DESCARGAR_DATA: `${materia_prima_i}-rccc194-descargar-data`,
                AUDTH: `${materia_prima_i}-rccc194-auditoria`,
                EDITAR_CORRECCIONES: `${materia_prima_i}-rccc194-editar-correcciones`,
            },
            TRANSACCIONES: `${materia_prima_t}-rccc194`,
        },
        RCCC03: {
            INFORMES: {
                VISUALIZAR: `${materia_prima_i}-rccc03-visualizar`,
                VISUALIZAR_PDF: `${materia_prima_i}-rccc03-visualizar-pdf`,
                FIRMAR: `${materia_prima_i}-rccc03-firmar`,
                EDITAR: `${materia_prima_i}-rccc03-editar`,
                DESCARGAR_PDF: `${materia_prima_i}-rccc03-descargar-pdf`,
                DESCARGAR_EXCEL: `${materia_prima_i}-rccc03-descargar-excel`,
                DESCARGAR_DATA: `${materia_prima_i}-rccc03-descargar-data`,
                AUDTH: `${materia_prima_i}-rccc03-auditoria`,
                EDITAR_CORRECCIONES: `${materia_prima_i}-rccc03-editar-correcciones`,
            },
            TRANSACCIONES: `${materia_prima_t}-rccc03`,
        },
    },
    PROD_TERMINADO: {
        VENTANA_INFORMES: `${prod_terminado_i}-ventana`,
        VENTANA_TRANSACCIONES: `${prod_terminado_t}-ventana`,
        RCCC108: {
            INFORMES: {
                VISUALIZAR: `${prod_terminado_i}-rccc108-visualizar`,
                VISUALIZAR_PDF: `${prod_terminado_i}-rccc108-visualizar-pdf`,
                FIRMAR: `${prod_terminado_i}-rccc108-firmar`,
                EDITAR: `${prod_terminado_i}-rccc108-editar`,
                DESCARGAR_PDF: `${prod_terminado_i}-rccc108-descargar-pdf`,
                DESCARGAR_EXCEL: `${prod_terminado_i}-rccc108-descargar-excel`,
                DESCARGAR_DATA: `${prod_terminado_i}-rccc108-descargar-data`,
                REVISAR: `${prod_terminado_i}-rccc108-revisar`,
                AUDTH: `${prod_terminado_i}-rccc108-auditoria`,
                EDITAR_CORRECCIONES: `${prod_terminado_i}-rccc108-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-prod-terminado-rccc108`,
        },
        RCCC198: {
            INFORMES: {
                VISUALIZAR: `${prod_terminado_i}-rccc198-visualizar`,
                VISUALIZAR_PDF: `${prod_terminado_i}-rccc198-visualizar-pdf`,
                FIRMAR: `${prod_terminado_i}-rccc198-firmar`,
                EDITAR: `${prod_terminado_i}-rccc198-editar`,
                DESCARGAR_PDF: `${prod_terminado_i}-rccc198-descargar-pdf`,
                DESCARGAR_EXCEL: `${prod_terminado_i}-rccc198-descargar-excel`,
                DESCARGAR_DATA: `${prod_terminado_i}-rccc198-descargar-data`,
                AUDTH: `${prod_terminado_i}-rccc198-auditoria`,
                EDITAR_CORRECCIONES: `${prod_terminado_i}-rccc198-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-prod-terminado-rccc198`,
        },
    },
    LABORATORIO: {
        VENTANA_INFORMES: `${laboratorio_i}-ventana`,
        VENTANA_TRANSACCIONES: `${laboratorio_t}-ventana`,
        RCCC119: {
            INFORMES: {
                VISUALIZAR: `${laboratorio_i}-rccc119-visualizar`,
                VISUALIZAR_PDF: `${laboratorio_i}-rccc119-visualizar-pdf`,
                FIRMAR: `${laboratorio_i}-rccc119-firmar`,
                EDITAR: `${laboratorio_i}-rccc119-editar`,
                DESCARGAR_PDF: `${laboratorio_i}-rccc119-descargar-pdf`,
                DESCARGAR_EXCEL: `${laboratorio_i}-rccc119-descargar-excel`,
                DESCARGAR_DATA: `${laboratorio_i}-rccc119-descargar-data`,
                REVISAR: `${laboratorio_i}-rccc119-revisar`,
                AUDTH: `${laboratorio_i}-rccc119-auditoria`,
                EDITAR_CORRECCIONES: `${laboratorio_i}-rccc119-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-laboratorio-rccc119`,
        },
        RCCC06: {
            INFORMES: {
                VISUALIZAR: `${laboratorio_i}-rccc06-visualizar`,
                VISUALIZAR_PDF: `${laboratorio_i}-rccc06-visualizar-pdf`,
                FIRMAR: `${laboratorio_i}-rccc06-firmar`,
                EDITAR: `${laboratorio_i}-rccc06-editar`,
                DESCARGAR_PDF: `${laboratorio_i}-rccc06-descargar-pdf`,
                DESCARGAR_EXCEL: `${laboratorio_i}-rccc06-descargar-excel`,
                DESCARGAR_DATA: `${laboratorio_i}-rccc06-descargar-data`,
                REVISAR: `${laboratorio_i}-rccc06-revisar`,
                AUDTH: `${laboratorio_i}-rccc06-auditoria`,
                EDITAR_CORRECCIONES: `${laboratorio_i}-rccc06-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-laboratorio-rccc06`,
        },
        RCCC256: {
            INFORMES: {
                VISUALIZAR: `${laboratorio_i}-rccc256-visualizar`,
                VISUALIZAR_PDF: `${laboratorio_i}-rccc256-visualizar-pdf`,
                FIRMAR: `${laboratorio_i}-rccc256-firmar`,
                EDITAR: `${laboratorio_i}-rccc256-editar`,
                DESCARGAR_PDF: `${laboratorio_i}-rccc256-descargar-pdf`,
                DESCARGAR_EXCEL: `${laboratorio_i}-rccc256-descargar-excel`,
                DESCARGAR_DATA: `${laboratorio_i}-rccc256-descargar-data`,
                REVISAR: `${laboratorio_i}-rccc256-revisar`,
                AUDTH: `${laboratorio_i}-rccc256-auditoria`,
                EDITAR_CORRECCIONES: `${laboratorio_i}-rccc256-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-laboratorio-rccc256`,
        },
        RCCC97: {
            INFORMES: {
                VISUALIZAR: `${laboratorio_i}-rccc97-visualizar`,
                VISUALIZAR_PDF: `${laboratorio_i}-rccc97-visualizar-pdf`,
                FIRMAR: `${laboratorio_i}-rccc97-firmar`,
                EDITAR: `${laboratorio_i}-rccc97-editar`,
                DESCARGAR_PDF: `${laboratorio_i}-rccc97-descargar-pdf`,
                DESCARGAR_EXCEL: `${laboratorio_i}-rccc97-descargar-excel`,
                DESCARGAR_DATA: `${laboratorio_i}-rccc97-descargar-data`,
                REVISAR: `${laboratorio_i}-rccc97-revisar`,
                AUDTH: `${laboratorio_i}-rccc97-auditoria`,
                EDITAR_CORRECCIONES: `${laboratorio_i}-rccc97-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-laboratorio-rccc97`,
        },
        RCCC41: {
            INFORMES: {
                VISUALIZAR: `${laboratorio_i}-rccc41-visualizar`,
                VISUALIZAR_PDF: `${laboratorio_i}-rccc41-visualizar-pdf`,
                FIRMAR: `${laboratorio_i}-rccc41-firmar`,
                EDITAR: `${laboratorio_i}-rccc41-editar`,
                DESCARGAR_PDF: `${laboratorio_i}-rccc41-descargar-pdf`,
                DESCARGAR_EXCEL: `${laboratorio_i}-rccc41-descargar-excel`,
                DESCARGAR_DATA: `${laboratorio_i}-rccc41-descargar-data`,
                REVISAR: `${laboratorio_i}-rccc41-revisar`,
                AUDTH: `${laboratorio_i}-rccc41-auditoria`,
                EDITAR_CORRECCIONES: `${laboratorio_i}-rccc41-editar-correcciones`,
            },
            TRANSACCIONES: `ver-control-calidad-transacciones-laboratorio-rccc41`,
        },
    },
}

export enum ControlCalidadPerms {
    VER_TRANSACCION_GENERAL = 'ver-control-calidad-transacciones-calidad-general-visualizar',
    VER_TRANSACCION_FISICO_QUIMICO = 'ver-control-calidad-transaccion-fisico-quimico',
    VER_TRANSACCION_PROCESO_ENTERO = 'ver-control-calidad-transaccion-proceso-entero',
    VER_TRANSACCION_PROCESO_COLA = 'ver-control-calidad-transaccion-proceso-cola',
    VER_TRANSACCION_SALMUERA = 'ver-control-calidad-transaccion-salmuera',
    VER_TRANSACCION_COCIDO = 'ver-control-calidad-transaccion-cocido',
    VER_TRANSACCION_VALOR_AGREGADO = 'ver-control-calidad-transaccion-valor-agregado',
    VER_TRANSACCION_TEMPERATURA = 'ver-control-calidad-transaccion-temperatura',
    VER_TRANSACCION_PANEL_CONTROL_RESPONSABLE = 'ver-control-calidad-transaccion-panel-control-responsable',
    VER_TRANSACCION_BANDEJA_CONTROL_ASIGNACIONES = 'ver-control-calidad-transaccion-bandeja-control-asignaciones',
    VER_TRANSACCION_ASIGNACION_RESPONSABLE = 'ver-control-calidad-transaccion-asignacion-responsable',
    VER_TRANSACCION_GLASEO = 'ver-control-calidad-transaccion-glaseo',
    VER_TRANSACCION_ETIQUETADO = 'ver-control-calidad-transaccion-etiquetado',
    VER_TRANSACCION_EMPAQUE = 'ver-control-calidad-transaccion-empaque',
    VER_TRANSACCION_PRODUCTO_TERMINADO = 'ver-control-calidad-transaccion-producto-terminado',
    VER_TRANSACCION_DETECTOR_METALES = 'ver-control-calidad-transaccion-detector-metales',
    VER_TRANSACCION_EMBARQUE_DESPACHO = 'ver-control-calidad-transaccion-embarque-despacho',
    VER_TRANSACCION_OTROS = 'ver-control-calidad-transaccion-otros',
    VER_TRANSACCIONES_CC_EMBARQUE = 'ver-control-calidad-transaccion-control-embarque',
    VER_TRANSACCIONES_CC_INSPECCION_PRELIMINAR = 'ver-control-calidad-transaccion-materia-prima',
    VER_TRANSACCIONES_CC_PT_CONTROL_VAL_AGREGADO_CONGELADO_FRESCO = 'ver-control-calidad-transacciones-pt-control-val-agr-con-fresco',
    VER_TRANSACCIONES_CC_DESCONGELADO_SALMUERA = 'ver-control-calidad-descongelado-salmuera',
    VER_TRANSACCIONES_CC_PROCESO_ENTERO_FRESCO = 'ver-control-calidad-proceso-fresco',
    VER_TRANSACCIONES_CC_CLASIFICACION_ENTERO_FRESCO = 'ver-control-calidad-clasificacion-camaron',
    VER_TRANSACCIONES_CC_CONTROL_PROCESO_CAMARON_COCIDO = 'ver-control-calidad-proceso-camaron-cocido',
    VER_TRANSACCIONES_CC_PRODUCTO_PELADO_FRESCO = 'ver-control-calidad-control-pelado-fresco',

    // Refactorizados
    VER_INFORMES_MATERIA_PRIMA_RCMP01 = 'ver-control-calidad-informes-materia-prima-rcmp01-visualizar', // RR
    VER_INFORMES_PROD_TERMINADO_RCCC108 = 'ver-control-calidad-informes-prod-terminado-rccc108-visualizar', // RR (Nuevo)

    // Informes
    VER_INFORME_INSPECCION_PRELIMINAR = 'ver-control-calidad-informe-inspeccion-preliminar',
    VER_INFORME_GARANTIA_PESCA = 'ver-control-calidad-informe-garantia-pesca',
    VER_INFORME_SAN_FELIPE = 'ver-control-calidad-informe-san-felipe',
    VER_INFORME_CLASIFICACION_CAMARON_ENTERO = 'ver-control-calidad-informe-clasificacion-camaron-entero',
    VER_INFORMES_PROCESO_ENTERO = 'ver-control-calidad-informes-proceso-entero',
    VER_INFORME_CAMARON_COLA_DESCABEZADO_ESPERA = 'ver-control-calidad-informe-camaron-cola-descabezado-espera',
    VER_INFORME_PROCESO_COLA_FRESCO = 'ver-control-calidad-informe-proceso-cola-fresco',
    VER_INFORME_CLASIFICACION_COLA_CAMARON = 'ver-control-calidad-informe-clasificacion-cola-camaron',
    VER_INFORME_PROCESO_COLA_FRECO_LAITRAM = 'ver-control-calidad-informe-proceso-cola-fresco-laitram',
    VER_INFORME_RESIDUAL_METABISULFITO = 'ver-control-calidad-informe-residual-metabisulfito',
    VER_INFORME_METODO_MONIER_WILLIAN = 'ver-control-calidad-informe-metodo-monier-willian',
    VER_INFORME_BANCO_MUESTRA = 'ver-control-calidad-informe-banco-muestra',
    VER_INFORME_RESISTENCIA_MELANOSIS = 'ver-control-calidad-informe-resistencia-melanosis',
    VER_INFORME_RECEPCION_GAVETA = 'ver-control-calidad-informe-recepcion-gaveta',
    VER_INFORME_PROCESO_ENTERO_FRESCO = 'ver-control-calidad-informe-proceso-entero-fresco',
    VER_INFORMES_ANALISIS_FISICO_QUIMICO_ORGANOLEPTICO = 'ver-control-calidad-informes-analisis-fisico-quimico-organoleptico',
    VER_INFORMES_PROCESO_COLA = 'ver-control-calidad-informes-proceso-cola',
    VER_INFORMES_COCIDO = 'ver-control-calidad-informes-cocido',
    VER_INFORME_LIBERACION_MATERIA_PRIMA_PRODUCTO_COCIDO = 'ver-control-calidad-informe-liberacion-materia-prima-producto-cocido',
    VER_INFORME_PROCESO_CAMARON_COCIDO = 'ver-control-calidad-informe-proceso-camaron-cocido',
    VER_INFORME_DESINFECCION_INSTRUMENTOS_ZONA_ALTO_RIESGO = 'ver-control-calidad-informe-desinfeccion-instrumentos-zona-alto-riesgo',
    VER_INFORMES_VALOR_AGREGADO = 'ver-control-calidad-informes-valor-agregado',
    VER_INFORME_PRODUCTO_PELADO_FRESCO = 'ver-control-calidad-informe-producto-pelado-fresco',
    VER_INFORME_CONSUMO_HIDRATANTES = 'ver-control-calidad-informe-consumo-hidratantes',
    VER_INFORME_INSPECCION_SABOR = 'ver-control-calidad-informe-inspeccion-sabor',
    VER_INFORME_EMPAQUE_PRODUCTO_TERMINADO = 'ver-control-calidad-informe-empaque-producto-terminado',
    VER_INFORME_EMPAQUE_VERIFICACION_ETIQUETADO = 'ver-control-calidad-informe-empaque-verificacion-etiquetado',
    VER_INFORME_EMPAQUE_REEMPAQUE_ETIQUETADO = 'ver-control-calidad-informe-empaque-reempaque-etiquetado',
    VER_INFORME_EMPAQUE_FUNDAS_SELLADAS = 'ver-control-calidad-informe-empaque-fundas-selladas',
    VER_INFORME_EMBARQUE_DESPACHO = 'ver-control-calidad-informes-embarque-despacho',
    VER_INFORME_OTROS_CONTROL_BALANZA = 'ver-control-calidad-informes-otros-control-balanza',
    VER_INFROME_OTROS_INSPECCION_TRANSPORTE = 'ver-control-calidad-informes-otros-inspeccion-transporte',
    VER_INFORME_OTROS_CONTROL_TERMOMETRO = 'ver-control-calidad-informes-otros-control-termometro',
    VER_INFORME_OTROS_RETIRO_ETIQUETAS = 'ver-control-calidad-informes-otros-retiro-etiquetas',
    VER_INFORME_OTROS_CARTONES = 'ver-control-calidad-informes-otros-cartones',
    VER_INFORME_CONTROL_TEMPERATURA_CAMARA = 'ver-control-calidad-informe-control-temperatura-camara',
    VER_INFORME_GUIA_SALIDA_PRODUCTO_CAMARA_DESCONGELADO = 'ver-control-calidad-informe-guia-salida-producto-camara-descongelado',
    VER_INFORME_REPORTE_TEMPERATURA_BINS = 'ver-control-calidad-informe-reporte-temperatura-bins',
    VER_INFORME_DESCONGELADO_VALOR_AGREGADO = 'ver-control-calidad-informe-descongelado-valor-agregado',
    VER_INFORMES_TEMPERATURA = 'ver-control-calidad-informes-temperatura',
    VER_INFORME_TEMPERATURA_PRODUCTO_CAMARON_COCIDO = 'ver-control-calidad-informe-temperatura-producto-camaron-cocido',
    VER_INFORME_TEMPERATURA_BINS_SOBRANTE_BAJA = 'ver-control-calidad-informe-temperatura-bins-sobrante-baja',
    VER_INFORME_TEMPERATURAS_AREA_IQF = 'ver-control-calidad-informe-temperaturas-area-iqf',
    VER_INFORME_TEMPERATURAS_AMBIENTE_NAVE_4 = 'ver-control-calidad-informe-temperaturas-ambiente-nave-4',
    VER_INFORME_TEMPERATURAS_AMBIENTE_AREA_SALMUERA = 'ver-control-calidad-informe-temperaturas-ambiente-area-salmuera',
    VER_INFORME_TEMPERATURAS_AMBIENTE_NAVE_3 = 'ver-control-calidad-informe-temperaturas-ambiente-nave-3',
    VER_INFORME_TEMPERATURAS_AMBIENTE_NAVE_2 = 'ver-control-calidad-informe-temperaturas-ambiente-nave-2',
    VER_INFORME_PT_CONTROL_ESCURRIDO = 'ver-control-calidad-informe-pt-control-escurrido',
    VER_INFORME_PT_ANALISIS_DE_PT = 'ver-control-calidad-informe-pt-analisis-pt',
    VER_INFORME_PT_CONTROL_RETRACTILADO = 'ver-control-calidad-informe-pt-control-retractilado',
    VER_INFORME_PT_CAMARON_COLA = 'ver-control-calidad-informe-pt-camaron-cola',
    VER_INFORME_PT_LIBERACION = 'ver-control-calidad-informe-pt-liberacion',
    VER_INFORME_PT_PESO_BRUTO = 'ver-control-calidad-informe-pt-peso-bruto',
    VER_PRODUCTO_TERMINADO_INFORMES = 'ver-control-calidad-informes-producto-terminado',
    VER_INFORME_ETIQUETADO = 'ver-control-calidad-informe-etiquetas',
    VER_INFORME_CONTROL_ETIQUETAS = 'ver-control-calidad-informe-control-etiquetas',
    VER_INFORMES_GLASEO = 'ver-control-calidad-informes-glaseo',
    VER_INFORME_CONTROL_AGUA_GLASEO = 'ver-control-calidad-informe-control-agua-glaseo',
    VER_INFORME_CONTROL_GLASEO_SALMUERA = 'ver-control-calidad-informe-control-glaseo-salmuera',
    VER_INFORME_NO_CONFORME = 'ver-control-calidad-informe-no-conforme',
    VER_INFORME_GENERAL = 'ver-control-calidad-informes-calidad-general-visualizar',
    VER_CERTIFICADO_CC = 'ver-control-calidad-certificado',
    // TODO: revisar si la unificacion de estos dos informes no necesita tener un nuevo perm
    VER_INFORME_CC_EMBARQUE = 'ver-control-calidad-informes-control-embarque',
    VER_INFORME_CC_ESTIBA = 'ver-control-calidad-informes-estiba-contenedor',
    VER_INFORME_SALMUERA = 'ver-control-calidad-reporte-salmuera',
    VER_CONFIGURAR_FIRMA_CONTRASENA = 'ver-control-calidad-configurar-firmas-contrasena',
    VER_CONFIGURAR_FIRMAS_USUARIOS = 'ver-control-calidad-configurar-firmas-usuarios',
    VER_CONFIGURAR_PODERES = 'ver-control-calidad-configurar-poderes',
    // VER_CONFIGURAR_PLANTAS = 'ver-control-calidad-configurar-plantas',
    // VER_CONFIGURAR_AREAS = 'ver-control-calidad-configurar-areas',
    VER_CONFIGURAR_PROCESOS = 'ver-control-calidad-configurar-procesos',
    VER_INFORME_TRAZABILIDAD = 'ver-control-calidad-informes-calidad-trazabilidad-visualizar',
    VER_INFORME_TRAZABILIDAD_LOTES = 'ver-control-calidad-informes-calidad-trazabilidad-lotes',
    VER_INFORME_ACCIONES_CORRECTIVAS = 'ver-control-calidad-informes-calidad-acciones-correctivas-visualizar',
}

export enum ControlCalidadRoutes {
    MATERIA_PRIMA = 'control-calidad-transaccion-materia-prima',
    FISICO_QUIMICO = 'control-calidad-transaccion-fisico-quimico',
    PROCESO_ENTERO = 'control-calidad-transaccion-proceso-entero',
    PROCESO_COLA = 'control-calidad-transaccion-proceso-cola',
    SALMUERA = 'control-calidad-transaccion-salmuera',
    COCIDO = 'control-calidad-transaccion-cocido',
    VALOR_AGREGADO = 'control-calidad-transaccion-valor-agregado',
    TEMPERATURA = 'control-calidad-transaccion-temperatura',
    PANEL_CONTROL_RESPONSABLE = 'control-calidad-transaccion-panel-control-responsable',
    BANDEJA_CONTROL_ASIGNACIONES = 'control-calidad-transaccion-bandeja-control-asignaciones',
    ASIGNACION_RESPONSABLE = 'control-calidad-transaccion-asignacion-responsable',
    GLASEO = 'control-calidad-transaccion-glaseo',
    ETIQUETADO = 'control-calidad-transaccion-etiquetado',
    EMPAQUE = 'control-calidad-transaccion-empaque',
    PRODUCTO_TERMINADO = 'control-calidad-transaccion-producto-terminado',
    DETECTOR_METALES = 'control-calidad-transaccion-detector-metales',
    EMBARQUE_DESPACHO = 'control-calidad-transaccion-embarque-despacho',
    OTROS = 'control-calidad-transaccion-otros',
    MATERIA_PRIMA_INFORMES = 'control-calidad-informes-materia-prima',
    ANALISIS_FISICO_QUIMICO_ORGANOLEPTICO_INFORMES = 'control-calidad-informes-analisis-fisico-quimico-organoleptico',
    PROCESO_ENTERO_INFORMES = 'control-calidad-informes-proceso-entero',
    PROCESO_COLA_INFORMES = 'control-calidad-informes-proceso-cola',
    COCIDO_INFORMES = 'control-calidad-informes-cocido',
    VALOR_AGREGADO_INFORMES = 'control-calidad-informes-valor-agregado',
    DETECTOR_DE_METALES_INFORMES = 'control-calidad-informes-detector-de-metales',
    EMBARQUE_DESPACHO_INFORMES = 'control-calidad-informes-embarque-despacho',
    EMPAQUE_INFORMES = 'control-calidad-informes-empaque',
    OTROS_INFORMES = 'control-calidad-informes-otros',
    TEMPERATURA_INFORMES = 'control-calidad-informes-temperatura',
    PRODUCTO_TERMINADO_INFORMES = 'control-calidad-informes-producto-terminado',
    ETIQUETADO_INFORMES = 'control-calidad-informes-etiquetado',
    GLASEO_INFORMES = 'control-calidad-informes-glaseo',
    NO_CONFORME_INFORMES = 'control-calidad-informes-no-conforme',
    GENERAL = 'control-calidad-informes-general',
    GENERAL_TRANSACCION = 'control-calidad-TRANSACCION-general',
    CERTIFICADO_CC = 'control-calidad-certificado',
    CONFIGURAR_FIRMA_CONTRASENA = 'control-calidad-configurar-firmas-contrasena',
    CONFIGURAR_FIRMAS_USUARIOS = 'control-calidad-configurar-firmas-usuarios',
    CONFIGURAR_PERMISOS_USUARIOS = 'control-calidad-configurar-permisos-usuarios',
    CONFIGURAR_PODERES = 'control-calidad-configurar-poderes',
    // CONFIGURAR_PLANTAS = 'control-calidad-plantas',
    // CONFIGURAR_AREAS = 'control-calidad-areas',
    CONFIGURAR_PROCESOS = 'control-calidad-procesos',
    TRAZABILIDAD_INFORME = 'control-calidad-informe-trazabilidad',
    ACCIONES_CORRECTIVAS_INFORMES = 'control-calidad-informe-acciones-correctivas',
    ACCIONES_CORRECTIVAS_ASIGNADAS_INFORMES = 'control-calidad-informe-acciones-correctivas-asignadas',
    ACCIONES_CORRECTIVAS_AREAS_ASIGNADAS_INFORMES = 'control-calidad-informe-acciones-correctivas-areas-asignados',
    ACCIONES_CORRECTIVAS_USUARIOS_ASIGNADOS_INFORMES = 'control-calidad-informe-acciones-correctivas-usuarios-asignados',
    DOCUMENTAL_INFORMES = 'control-calidad-informes-documental',
    DOCUMENTAL_TRANSACCIONES = 'control-calidad-transacciones-documental',
    DOCUMENTAL_TRANSACCIONES_GENERAL = 'control-calidad-transacciones-general-documental',
    DOCUMENTAL_INFORMES_GENERAL = 'control-calidad-infomes-general-documental',
    DOCUMENTAL_TRANSACCIONES_GENERAL_FINAL = 'control-calidad-transacciones-general-documental-final',
    DOCUMENTAL_INFORMES_GENERAL_FINAL = 'control-calidad-infomes-general-documental-final',

    TRANSACCION_PROCESOS = 'control-calidad-transaccion-proceso',
    INFORMES_PROCESOS = 'control-calidad-informe-proceso',
    TRAZABILIDAD_PROCESOS = 'control-calidad-trazabilidad-procesos',
    //mantenimiento
    MANTENIMIENTO = 'control-calidad-mantenimiento',
    TRAZABILIDAD_LOTES = 'control-calidad-informes-trazabilidad-lotes',
}

export const ControlCalidadRutasInformes = {
    CERTIFICADO_CC: () => import('@pages/controlCalidad/informes/Calidad/RegistroCertificadoCalidad.vue'),
    RC_CC_25: () => import('@pages/controlCalidad/informes/EmbarqueDespacho/RCCC25/Registro25.vue'),
    RC_CC_26: () => import('@pages/controlCalidad/informes/EmbarqueDespacho/RCCC26/Registro26.vue'),
    RC_MP_01: () => import('@pages/controlCalidad/informes/materiaPrima/RCMP01/Reporte01.vue'),
    CC_F_072: () => import('@pages/controlCalidad/informes/materiaPrima/CCF072/Reporte072.vue'),
    RC_CC_108: () => import('@pages/controlCalidad/informes/ProdTerminado/RCCC108/Reporte108.vue'),
    RC_CC_198: () => import('@pages/controlCalidad/informes/ProdTerminado/RCCC198/Reporte198.vue'),
    RC_CC_15: () => import('@pages/controlCalidad/informes/salmuera/RCCC15/Reporte15.vue'),
    RC_CC_07: () => import('@pages/controlCalidad/informes/procesoEntero/RCCC07/Reporte07.vue'),
    RC_CC_08: () => import('@pages/controlCalidad/informes/procesoEntero/Reporte08.vue'),
    CC_F_065: () => import('@pages/controlCalidad/informes/procesoEntero/CCF065/Reporte065.vue'),
    RC_CC_219: () => import('@pages/controlCalidad/informes/cocido/RCCC219/Registro219.vue'),
    RC_CC_103: () => import('@pages/controlCalidad/informes/ValorAgregado/RCCC103/Reporte103.vue'),
    RC_CC_25_26: () => import('@pages/controlCalidad/informes/EmbarqueDespacho/Registro25I26.vue'),
    RC_CC_23: () => import('@pages/controlCalidad/informes/procesoCola/Reporte23.vue'),
    CC_F_075: () => import('@pages/controlCalidad/informes/procesoCola/CCF075/Reporte075.vue'), // INCOMPLETO
    RC_CC_06: () => import('@pages/controlCalidad/informes/laboratorio/registro06/Reporte06.vue'), // INCOMPLETO
    RC_CC_256: () => import('@pages/controlCalidad/informes/laboratorio/registro256/Reporte256.vue'), // INCOMPLETO
    RC_CC_119: () => import('@pages/controlCalidad/informes/laboratorio/registro119/Reporte119.vue'), // INCOMPLETO
} as const

export const ControlCalidadRutasTransacciones = {
    RC_CC_25: () => import('@pages/controlCalidad/transacciones/EmbarqueDespacho/RCCC25/Control25.vue'), // INCOMPLETO
    RC_CC_26: () => import('@pages/controlCalidad/transacciones/EmbarqueDespacho/RCCC26/Control26.vue'), // INCOMPLETO
    RC_MP_01: () => import('@pages/controlCalidad/transacciones/MateriaPrima/registro01/Control01.vue'),
    CC_F_072: () => import('@pages/controlCalidad/transacciones/MateriaPrima/CCF072/Control072.vue'),
    RC_CC_108: () => import('@pages/controlCalidad/transacciones/ProductoTerminado/RCCC108/Control108.vue'),
    RC_CC_198: () => import('@pages/controlCalidad/transacciones/ProductoTerminado/RCCC198/Control198.vue'), // EN PROCESO
    RC_CC_15: () => import('@pages/controlCalidad/transacciones/Salmuera/RCCC15/Control15.vue'),
    RC_CC_07: () => import('@pages/controlCalidad/transacciones/ProcesoEntero/RCCC07/Control07.vue'),
    RC_CC_08: () => import('@pages/controlCalidad/transacciones/ProcesoEntero/registro08/Control08.vue'),
    CC_F_065: () => import('@pages/controlCalidad/transacciones/ProcesoEntero/CCF065/Control065.vue'),
    RC_CC_219: () => import('@pages/controlCalidad/transacciones/Cocido/Control219.vue'), // INCOMPLETO
    RC_CC_103: () => import('@pages/controlCalidad/transacciones/ValorAgregado/RCCC103/Control103.vue'),
    // Todo: Corregir importacion para ventana de transacciones
    RC_CC_25_26: () => import('@pages/controlCalidad/transacciones/EmbarqueDespacho/Control25I26.vue'), // INCOMPLETO
    RC_CC_201: () => import('@pages/controlCalidad/transacciones/Correcciones/Control201.vue'),
    RC_CC_23: () => import('@pages/controlCalidad/transacciones/ProcesoCola/registro23/Control23.vue'),
    CC_F_075: () => import('@pages/controlCalidad/transacciones/ProcesoCola/CCF075/Control075.vue'), // INCOMPLETO
    RC_CC_06: () => import('@pages/controlCalidad/transacciones/laboratorio/registro06/Control06.vue'), // INCOMPLETO
    RC_CC_256: () => import('@pages/controlCalidad/transacciones/laboratorio/registro256/Control256.vue'), // INCOMPLETO
    RC_CC_119: () => import('@pages/controlCalidad/transacciones/laboratorio/registro119/Control119.vue'), // INCOMPLETO
} as const

export const PermisosProceso = {
    GRAMAJE: {
        INFORMES: {
            VISUALIZAR: `${control_calidad_base}-informes-gramaje-visualizar`,
            VISUALIZAR_PDF: `${control_calidad_base}-informes-gramaje-visualizar-pdf`,
            FIRMAR: `${control_calidad_base}-informes-gramaje-firmar`,
            FIRMA_INDIVIDUAL: `${control_calidad_base}-informes-gramaje-firma-individual`,
            EDITAR: `${control_calidad_base}-informes-gramaje-editar`,
            DESCARGAR_PDF: `${control_calidad_base}-informes-gramaje-descargar-pdf`,
            DESCARGAR_EXCEL: `${control_calidad_base}-informes-gramaje-descargar-excel`,
            DESCARGAR_DATA: `${control_calidad_base}-informes-gramaje-descargar-data`,
            REVISAR: `${control_calidad_base}-informes-gramaje-revisar`,
            AUDTH: `${control_calidad_base}-informes-gramaje-auditoria`,
            EDITAR_CORRECCIONES: `${control_calidad_base}-informes-gramaje-editar-correcciones`,
        },
        TRANSACCIONES: `${control_calidad_base}-transacciones-gramaje`,
    },
    PROD_TERMINADO: {
        INFORMES: {
            VISUALIZAR: `${control_calidad_base}-informes-prod-terminado-visualizar`,
            VISUALIZAR_PDF: `${control_calidad_base}-informes-prod-terminado-visualizar-pdf`,
            FIRMAR: `${control_calidad_base}-informes-prod-terminado-firmar`,
            FIRMA_INDIVIDUAL: `${control_calidad_base}-informes-prod-terminado-firma-individual`,
            EDITAR: `${control_calidad_base}-informes-prod-terminado-editar`,
            DESCARGAR_PDF: `${control_calidad_base}-informes-prod-terminado-descargar-pdf`,
            DESCARGAR_EXCEL: `${control_calidad_base}-informes-prod-terminado-descargar-excel`,
            DESCARGAR_DATA: `${control_calidad_base}-informes-prod-terminado-descargar-data`,
            REVISAR: `${control_calidad_base}-informes-prod-terminado-revisar`,
            AUDTH: `${control_calidad_base}-informes-prod-terminado-auditoria`,
            EDITAR_CORRECCIONES: `${control_calidad_base}-informes-prod-terminado-editar-correcciones`,
        },
        TRANSACCIONES: `${control_calidad_base}-transacciones-prod-terminado`,
    },
    GENERAL: {
        INFORMES: `${control_calidad_base}-informes-procesos-general`,
        TRANSACCIONES: `${control_calidad_base}-transacciones-procesos-general`,
    },
    MANTENIMIENTO: {
        VISUALIZAR: `${control_calidad_base}-mantenimiento-base`,
        VISUALIZAR_ESTADOS: `${control_calidad_base}-mantenimiento-base-estados`,
        VISUALIZAR_PERMISOS: `${control_calidad_base}-mantenimiento-base-permisos`,
    },
    CONFIGURACION: {
        USUARIOS: {
            VISUALIZAR: `${control_calidad_base}-configuracion-usuarios-visualizar`,
            PERMISOS_MASIVOS: `${control_calidad_base}-configuracion-usuarios-permisos-masivos`,
            EDITAR_USUARIOS: `${control_calidad_base}-configuracion-usuarios-editar-usuarios`,
            INACTIVAR_USUARIOS: `${control_calidad_base}-configuracion-usuarios-inactivar-usuarios`,
            AGREGAR_USUARIOS: `${control_calidad_base}-configuracion-usuarios-agregar-usuarios`,
            VER_PDF: `${control_calidad_base}-configuracion-usuarios-ver-pdf`,
        },
        REGISTROS: {
            CAMBIAR_PLANTA: `${control_calidad_base}-configuracion-registros-cambiar-planta`,
            CAMBIAR_LOGS: `${control_calidad_base}-configuracion-registros-cambiar-logs`,
            DESDOCUMENTAR: `${control_calidad_base}-configuracion-registros-desdocumentar`,
            ANULAR: `${control_calidad_base}-configuracion-registros-anular`,
            BYPASS_BLOQUEO_EDICION_FIRMAS: `${control_calidad_base}-configuracion-registros-bypass-bloqueo-edicion-firmas`,
            VISUALIZAR: `${control_calidad_base}-configuracion-registros-visualizar`,
        },
    },
}

export const RutasProcesoInformes = {
    GRAMAJE: () => import('@pages/controlCalidad/informes/gramaje/ReporteGramaje.vue'),
    PROD_TERMINADO: () => import('@pages/controlCalidad/informes/prodTerminado/ReporteProdTerminado.vue'),
} as const

export const RutasProcesoTransacciones = {
    GRAMAJE: () => import('@pages/controlCalidad/transacciones/gramaje/ControlGramaje.vue'),
    PROD_TERMINADO: () => import('@pages/controlCalidad/transacciones/prodTerminado/ControlProdTerminado.vue'),
} as const
export const RutasProcesoTrazabilidad = {
    GRAMAJE: () => import('@pages/controlCalidad/informes/trazabilidad/TrazabilidadGramaje.vue'),
    PROD_TERMINADO: () => import('@pages/controlCalidad/informes/trazabilidad/TrazabilidadProdTerminado.vue'),
} as const
export enum Agreement {
    '1' = 'Santa Priscila',
    '2' = 'Troack',
}
export enum TipoDeInspeccion {
    '0' = 'COLA',
    '1' = 'ENTERO',
}

export const TipoDeInspeccionProdTerminado = {
    ENTERO: 1,
    COLA: 2,
}

export const METODO_CONGELACION = {
    BLOCK: 12,
    IQF_BRINE: 13,
    SEMI_IQF: 14,
    IQF: 15,
    FRESCO: 23,
}
export const FirmasProdTerminado = {
    REALIZADO_POR: 1,
    REVISADO_POR: 2,
    RESPONSABLE_PRODUCCION: 3,
    VERIFICADO_POR: 4,
}

export const coGuia = [
    { label: 'Guía de movilización', value: 1 },
    { label: 'Guía de virtual', value: 2 },
]

export const seccionesFirmas = {
    GRAMAJE: {
        REALIZADO_POR: 1,
        REVISADO_POR: 2,
        RESPONSABLE_PRODUCCION: 3,
        VERIFICADO_POR: 4,
    },
    PROD_TERMINADO: {
        REALIZADO_POR: 1,
        REVISADO_POR: 2,
        RESPONSABLE_PRODUCCION: 3,
        VERIFICADO_POR: 4,
    },
}
//TODO: mejorar esto
export const labelSeccionesFirmas = {
    1: 'Monitor',
    2: 'Supervisor',
    3: 'Responsable de producción',
    4: 'Calidad',
}

export const TipoIngresoPeso = {
    MASTER: 1,
    CAJA_O_FUNDA: 2,
}

export const TipoPeso = {
    PESO_BRUTO: 1,
    PESO_EMPAQUE: 2,
    PESO_NETO: 3,
    PESO_MAQUINA: 4,
}
export const UnidadMedida = {
    KG: 2,
    LB: 3,
}
export const UnidadDeMedidaSigla = {
    KILOGRAMOS: 'KG',
    LIBRAS: 'LB',
}
export const itemEstado = {
    activo: 1,
    inactivo: 0,
}
